<template>
    <div class="page">
        <div class="tabs">
            <div
                class="tab"
                :class="[tabActiveIndex == 0 ? 'active' : '']"
                @click="changeTab(0)"
            >
                新增购买
            </div>
            <div
                class="tab"
                :class="[tabActiveIndex == 1 ? 'active' : '']"
                @click="changeTab(1)"
            >
                已购
            </div>
        </div>
        <div class="list list0" :class="[tabActiveIndex == 0 ? 'active' : '']">
            <div
                class="item"
                v-for="(item, index) in piliangConfig"
                :key="index"
            >
                <div class="top">
                    <div
                        class="left"
                        :style="
                            'background:url(' +
                            item.adImg +
                            ') no-repeat center/cover'
                        "
                    ></div>
                    <div class="right">
                        <div class="title">{{ item.title }}</div>
                        <div class="prices-box">
                            <div
                                class="price"
                                v-for="price in item.specs"
                                :key="price.id"
                                @click="changePrice(index, price.id)"
                                :class="[
                                    item.goodsId == price.id ? 'active' : '',
                                ]"
                            >
                                <div class="circle"></div>
                                <span>{{ price.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <span>购买数量</span>
                    <van-stepper
                        min="0"
                        v-model="item.num"
                        @change="calcPrice()"
                    />
                </div>
            </div>
        </div>
        <div class="list list1" :class="[tabActiveIndex == 1 ? 'active' : '']">
            <div class="item" v-for="(item, index) in myPiliang" :key="index">
                <div class="top">
                    <div
                        class="left"
                        :style="
                            'background:url(' +
                            item.adImg +
                            ') no-repeat center/cover'
                        "
                    ></div>
                    <div class="right">
                        <div
                            class="buyed-item"
                            v-for="(buyed, index) in item.list"
                            :key="index"
                        >
                            <div>{{ buyed.title }} {{ buyed.name }}会员</div>
                            <div>
                                <span
                                    >￥{{ buyed.price }}
                                    <span class="num"
                                        >x{{ buyed.num }}</span
                                    ></span
                                >
                                <button
                                    @click="
                                        goBulkBuyCode(item.id, buyed.goodsId)
                                    "
                                >
                                    兑换码
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <span>购买时间:{{ item.createTime }}</span>
                </div>
            </div>
        </div>
        <div class="total-price" :class="[tabActiveIndex == 0 ? 'active' : '']">
            <div>合计：￥{{ total }}</div>
            <div @click="submit()">去结算</div>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant";
import bulkBuyService from "../../service/bulk-buy.service";
export default {
    name: "bulk-buy",
    data() {
        return {
            tabActiveIndex: 0,
            total: 0,
            piliangConfig: [],
            myPiliang: [],
        };
    },
    created() {
        this.tabActiveIndex = this.$route.query.tabIndex || 0;
        bulkBuyService.getPiliangConfig().then((res) => {
            this.piliangConfig = res.data.map((item) => {
                item.num = 0;
                item.goodsId = "";
                return item;
            });
        });
        bulkBuyService.getMyPiliang().then((res) => {
            this.myPiliang = res.data;
        });
    },
    methods: {
        goBulkBuyCode(id, specId) {
            this.$router.push(`/bulk-buy-code/${id}/${specId}`);
        },
        changeTab(index) {
            this.tabActiveIndex = index;
        },
        changePrice(index, id) {
            this.piliangConfig[index].specs.forEach((item) => {
                if (item.id == id) {
                    if (this.piliangConfig[index].goodsId != id) {
                        this.piliangConfig[index].goodsId = id;

                        if (this.piliangConfig[index].num > 0) {
                            this.calcPrice();
                        }
                    }
                }
            });
        },
        calcPrice() {
            bulkBuyService
                .getPiliangPrice({ list: this.piliangConfig })
                .then((res) => {
                    this.total = res.data.price || 0;
                });
        },
        submit() {
            bulkBuyService
                .createPiliang({ list: this.piliangConfig })
                .then((res) => {
                    let { goodsCode, goodsId } = res.data;
                    this.$router.push(`/pay/${goodsCode}?id=${goodsId}`);
                })
                .catch((error) => {
                    Toast(error.response.data);
                });
        },
    },
};
</script>

<style lang="scss" scoped src="./bulk-buy.scss">
</style>